var _path, _path2, _rect, _g, _rect2, _rect3, _rect4, _rect5, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcComplaintServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 93,
    viewBox: "0 0 103 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0747 21.6836C43.0747 18.1487 45.9402 15.2832 49.4751 15.2832H95.8909V83.7352C95.8909 87.27 93.0253 90.1355 89.4905 90.1355H43.0747V21.6836Z",
    fill: "#FFCF85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7422 15.2832H96.4853C100.02 15.2832 102.886 18.1487 102.886 21.6836V40.7126C102.886 44.2474 100.02 47.1129 96.4853 47.1129H92.7422V15.2832Z",
    fill: "#FFCF85"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.1685,
    y: 27.5254,
    width: 34.6278,
    height: 9.44398,
    fill: "#FFF2DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_266)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.750977,
    y: 3.79297,
    width: 58.2358,
    height: 77.2191,
    rx: 2.3274,
    fill: "#F4F4F4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8945,
    y: 38.0088,
    width: 37.9659,
    height: 1.92377,
    rx: 0.961887,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8945,
    y: 45.1689,
    width: 37.9659,
    height: 1.92377,
    rx: 0.961887,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8945,
    y: 52.3301,
    width: 37.9659,
    height: 1.92377,
    rx: 0.961887,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8945,
    y: 59.4902,
    width: 27.2825,
    height: 1.92377,
    rx: 0.961887,
    fill: "#DFDFDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8862 21.9806V22.6159C25.8862 23.458 25.8862 24.4035 25.6129 25.8291L24.6674 25.7331C24.9222 24.4626 24.9333 23.5171 24.9407 22.7267H20.9814V21.9806H25.8862ZM26.4772 26.5309V27.2991H20.3461V26.5309H22.54V24.2188H23.4781V26.5309H26.4772ZM33.0366 26.5604V27.3139H26.8834V26.5604H29.454V25.0388H30.3921V26.5604H33.0366ZM30.4217 22.2613C30.4217 23.2216 31.2859 24.2336 32.8224 24.47L32.4235 25.253C31.2416 25.0388 30.3626 24.4072 29.9194 23.5688C29.4762 24.4035 28.6046 25.0424 27.4301 25.253L27.0312 24.47C28.5528 24.2336 29.4097 23.2142 29.4171 22.2613V21.7812H30.4217V22.2613ZM37.2397 21.8477V22.6011H35.9027C35.9101 23.3841 36.3791 24.1413 37.4539 24.4552L37.0033 25.1939C36.2609 24.9686 35.7476 24.518 35.4521 23.9381C35.1529 24.6177 34.6063 25.1569 33.7975 25.4229L33.3173 24.6768C34.4327 24.3259 34.935 23.4543 34.9498 22.6011H33.5758V21.8477H37.2397ZM38.754 21.3971V22.9557H39.6626V23.7239H38.754V25.3859H37.8085V21.3971H38.754ZM36.5527 25.5189C37.9488 25.5115 38.8205 25.9916 38.8205 26.8116C38.8205 27.6315 37.9488 28.119 36.5527 28.119C35.1271 28.119 34.248 27.6315 34.248 26.8116C34.248 25.9916 35.1271 25.5115 36.5527 25.5189ZM36.5527 26.2502C35.6663 26.2502 35.1862 26.4349 35.1936 26.8116C35.1862 27.1957 35.6663 27.3877 36.5527 27.3877C37.4244 27.3877 37.8897 27.1957 37.8897 26.8116C37.8897 26.4349 37.4244 26.2502 36.5527 26.2502Z",
    fill: "#374969"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_266",
    x: 0.750977,
    y: 3.79297,
    width: 62.8906,
    height: 81.8736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.3274,
    dy: 2.3274
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1637
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_266",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplaintServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcComplaintServiceMainMobile.a78ea88e37d1edac4b53c9c6150de4bb.svg";
export { ForwardRef as ReactComponent };